import ManageAssignmentsPage from "@Alternatives/Assignments/Pages/ManageAssignmentsPage.vue";

export const routes = [
    {
        path: "/portfolio/assignments/:workspaceId/:tchProjectId",
        component: ManageAssignmentsPage
    },
    {
        path: "/decision/assignments/:workspaceId/:tchProjectId",
        component: ManageAssignmentsPage
    },
]
